if (!customElements.get('variant-info-system')) {
  class VariantInfoSystem extends HTMLElement {
    connectedCallback() {
      this.modalId = this.dataset.modalId;
      this.modal = document.getElementById(this.modalId);
      this.content = this.modal?.querySelector('[data-variant-info-modal-content]');
      this.triggerTemplate = this.querySelector('[data-variant-info-trigger-template]');
      this.scope = this.closest('product-info, .pc-buybox, section') || this.parentElement;
      this.locale = String(document.documentElement.lang || 'de').toLowerCase().startsWith('en') ? 'en' : 'de';

      if (!this.modal || !this.content || !this.triggerTemplate || !this.scope) return;

      this.templates = [...this.querySelectorAll('[data-variant-info-template]')];
      this.enhanceGroups();

      this.observer = new MutationObserver(() => this.enhanceGroups());
      this.observer.observe(this.scope, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-');
    }

    templateFor(group) {
      const heading = group.querySelector(':scope > legend, :scope > .form__label, :scope > .pc-variant-legend');
      const rawKey =
        group.dataset.optionName ||
        group.dataset.consoleAddonGroup ||
        heading?.childNodes?.[0]?.textContent ||
        heading?.textContent;
      const key = this.normalize(rawKey);

      return this.templates.find((template) => {
        if ((template.dataset.locale || 'de') !== this.locale) return false;
        const aliases = (template.dataset.variantInfoAliases || template.dataset.variantInfoKey || '')
          .split(',')
          .map((alias) => this.normalize(alias));
        return aliases.includes(key);
      });
    }

    enhanceGroups() {
      const groups = this.scope.querySelectorAll(
        '.product-form__input[data-option-name], [data-console-addon-group], .pc-variant-group[data-option-name]'
      );

      groups.forEach((group) => {
        const template = this.templateFor(group);
        if (!template) return;

        const key = template.dataset.variantInfoKey;
        if (group.dataset.variantInfoEnhanced === key) return;

        const heading = group.querySelector(':scope > legend, :scope > .form__label, :scope > .pc-variant-legend');
        if (!heading) return;

        const trigger = this.triggerTemplate.content.firstElementChild.cloneNode(true);
        const label = template.dataset.variantInfoLabel || heading.textContent.trim();
        const buttonLabel = template.dataset.variantInfoButtonLabel || `Mehr Informationen zu ${label}`;

        trigger.dataset.variantInfoTrigger = key;
        trigger.setAttribute('aria-label', buttonLabel);
        trigger.setAttribute('aria-controls', this.modalId);
        trigger.setAttribute('title', buttonLabel);
        trigger.addEventListener('click', () => this.open(template, trigger));

        heading.classList.add('variant-info__heading');
        heading.append(trigger);
        group.dataset.variantInfoEnhanced = key;
      });
    }

    open(template, trigger) {
      this.content.replaceChildren(template.content.cloneNode(true));
      this.modal.show(trigger);
    }
  }

  customElements.define('variant-info-system', VariantInfoSystem);
}
